// Single source of the RudderStack anonymousId for Rails-served JS. Only the
// live SDK id is used: it is the id the Braze web SDK aliases as rudder_id, so
// backend sign_up / generate_lead / purchase events keyed on it land on the
// same Braze profile. Nothing else is a substitute — gon.anonymous_id is the
// server-minted marketing cookie (a different id namespace with no Braze
// alias), and the rl_anonymous_id cookie is stored encoded (RS_ENC_v3_... by
// the v3 SDK, RudderEncrypt:... by the legacy SDK). When the SDK has no id yet
// return undefined and let the backend decode the SDK cookie itself; never mint
// an id here.
const isPlainId = (value) =>
  typeof value === 'string' &&
  value.length > 0 &&
  !value.startsWith('RS_ENC_') &&
  !value.startsWith('RudderEncrypt:');

export const getRudderstackAnonymousId = () => {
  try {
    const sdkId = window.rudderanalytics?.getAnonymousId?.();
    return isPlainId(sdkId) ? sdkId : undefined;
  } catch (e) {
    // Pre-load snippet stub or a half-initialised SDK: no usable id yet.
    return undefined;
  }
};
